module.exports = __webpack_public_path__ + "daniel_hoglund_round-4e3a02639a0e41046dde5eb8817fde5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/daniel_hoglund_round.jpg
// module id = 1181
// module chunks = 1 2